export default __webpack_public_path__ + "static/media/short stay - Visiting FriendsFamily.aaea95fd.jpg";